import React from 'react'
import {change as changeFieldValue, Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';
import {renderFieldTelefone} from '../../util/inputs';
import cadastrarEmpresa from '../../actions/empresa/cadastrarEmpresas';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import alterarEmpresa from '../../actions/empresa/alterarEmpresas';
import {showSuccessMsg} from '../../util/messagesUtil';

const renderField = ({
                         input,
                         label,
                         type,
                         css,
                         max,
                         readOnly,
                         meta: {touched, error}
                     }) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <input {...input} type={type}
                   className={css}
                   maxLength={max}
                   id={input.name}
                   style={{borderColor: touched && error ? 'red' : ''}}
                   disabled={readOnly}
                   readOnly={readOnly}/>
            {touched
            && (error && <span style={{color: 'red'}}>{error}</span>)}
        </div>
    </div>
);

export const validate = (values) => {
    const erros = {};
    if (!values.nome) {
        erros.nome = 'Campo obrigatório'
    }
    if (!values.email) {
        erros.email = 'Campo obrigatório'
    }

    return erros
};

export class PessoasEmpresa extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);

        this.state = {
            usuario: null,
        };
    }

    fecharModal() {
        $('#modalCadastrarEmpresa')
            .modal('hide');
        $('#modalCadastrarEmpresa')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.reset('formularioCadastroEmpresa');
        this.props.limparCampos();
    }


    submit(values) {

        const parametros = this.props.montarParametroEmpresa(values)

        const formData = new FormData();
        formData.append('file', new Blob([this.props.arquivo], {type: 'application/octet-stream'}), this.props.arquivo);
        formData.append('empresa', new Blob([JSON.stringify(parametros)], {type: 'application/json'}));
        if (values.codigoEmpresa) {
            this.props.alterarEmpresa(formData).then(() => {
                showSuccessMsg('Empresa atualizado com sucesso');
                this.props.buscarEmpresas();
                this.fecharModal();
            })
        } else {
            this.props.cadastrarEmpresa(formData).then(() => {
                showSuccessMsg('Empresa cadastrada com sucesso');
                this.props.reset('formularioCadastroEmpresa');
                this.props.destroy();
                this.props.buscarEmpresas();
                this.fecharModal();
            })
        }
    }

    render() {
        const {
            handleSubmit, submitting, invalid, pristine, paginaAnterior
        } = this.props;
        return (
            <div className="modal-body">
                <form onSubmit={handleSubmit(this.submit)}>
                    <fieldset className="border p-2">
                        <legend className="w-auto">Dono da empresa</legend>
                        <div className="form-row">
                            <div className="col-12 col-sm-9 col-md-9">
                                <Field name="nomeDono" type="text" component={renderField} label="Nome completo:"
                                       css="form-control" readOnly={false}/>
                            </div>
                        </div>
                        <div className="form-group">
                            <Field name="telefoneDono" type="text" component={renderFieldTelefone}
                                   css="form-control col-md-6" label="Telefone"/>
                        </div>
                    </fieldset>
                    <fieldset className="border p-2">
                        <legend className="w-auto">Sócio da empresa</legend>
                        <div className="form-row">
                            <div className="col-12 col-sm-9 col-md-9">
                                <Field name="nomeSocio" type="text" component={renderField} label="Nome completo:"
                                       css="form-control" readOnly={false}/>
                            </div>
                        </div>
                        <div className="form-group">
                            <Field name="telefoneSocio" type="text" component={renderFieldTelefone}
                                   css="form-control col-md-6" label="Telefone"/>
                        </div>
                    </fieldset>
                    <fieldset className="border p-2">
                        <legend className="w-auto">Gerente da empresa</legend>
                        <div className="form-row">
                            <div className="col-12 col-sm-9 col-md-9">
                                <Field name="nomeGerente" type="text" component={renderField} label="Nome completo:"
                                       css="form-control" readOnly={false}/>
                            </div>
                        </div>
                        <div className="form-group">
                            <Field name="telefoneGerente" type="text" component={renderFieldTelefone}
                                   css="form-control col-md-6" label="Telefone"/>
                        </div>
                    </fieldset>

                    <div className="form-group">
                    </div>
                    <div className="form-group area-codigo">
                        <Field name="codigoEmpresa" type="hidden" component={renderField}
                               css="form-control col-md-12"/>
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-light" onClick={paginaAnterior}>Voltar
                        </button>
                        <button type="submit" disabled={invalid || submitting || pristine}
                                className="btn btn-laranja" id="salvar-empresa">Salvar
                        </button>
                    </div>
                </form>
            </div>

        );
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarEmpresa,
        alterarEmpresa,
        selecionarOrigem
    }, dispatch)
);

export default connect(null, mapDispatchToProps)(
    reduxForm({
        form: 'formularioCadastroEmpresa',
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate
    })(PessoasEmpresa));
